import { useRfiData } from "hooks/queries";
import React from "react";
import { useNavigate } from "react-router-dom";

import { SortDescriptor } from "@progress/kendo-data-query";
import LoadingComponentOverlay from "components/LoadingComponentOverlay";
import { orderBy } from "lodash";
import { GetRfiDataOptions, RfiData } from "types/RfiTypes";
import SingleMyActiveRfi from "./SingleMyActiveRfi";


const options: GetRfiDataOptions = {
  countOnly: false,
  includeElements: false,
  activeRfis: true,
  myRfis: true,
  includeMappedTo: false,
};

const initialSort: Array<SortDescriptor> = [
  { field: "responsesDueDate", dir: "asc" },
 
];


const MyActiveRfisTile = () => {

  const navigate = useNavigate();
  
  const [sort, setSort] = React.useState(initialSort);
  
  const { isLoading, data } = useRfiData(0, 0, sort, null, options); 

  if(isLoading) return(
    <>
    <LoadingComponentOverlay active={isLoading}>
    <h1 className="h3">My Active RFIs</h1> 
    <div className="my-active-rfi">      
      
          <SingleMyActiveRfi 
            rfi={null}
            key={0}
          ></SingleMyActiveRfi>
            
    </div>  
    </LoadingComponentOverlay>
    </> 
    
    );  
   
    const sortedData = orderBy(data.records, ["alertDays", "title"], ["asc", "asc"])

    
  return (
    <>
    <h1 className="h3">My Active RFIs</h1> 
    <div className="my-active-rfi">      
      {sortedData?.map((rfi:RfiData) => {
        return (
          <SingleMyActiveRfi 
            rfi={rfi}
            key={rfi.rfiId}
          ></SingleMyActiveRfi>
        )
      })}      
    </div>  
    </>     
  );
};

export default MyActiveRfisTile;
